import React from 'react';
import Translator from '../../../core/i18n';
import { QuestionType } from '../../../models/enums/QuestionType';
import { QuestionBankDownloadTemplateExcel } from '../../../store/actions/question';
import { useDispatch } from 'react-redux';
interface FileDownloaderProps {
    questionType: QuestionType;
}

const T = Translator.create();
const ExcelTemplateDownload: React.FC<FileDownloaderProps> = ({ questionType }) => {

    const dispatch = useDispatch();

    const handleDownload = () => {
        dispatch(QuestionBankDownloadTemplateExcel(questionType, "questionBankDownloadTemplateExcel", "get"))
    };

    return (
        <div className="upload-files-name">
            <button type="button" className="file-name" onClick={handleDownload}>
                <i className="material-icons">save_alt</i>
                {T.t('r_excel_template_download')}
            </button>
        </div>
    );
}

export default ExcelTemplateDownload;
